import { jsx } from "react/jsx-runtime";
import React__default, { useState, useEffect } from "react";
import { Popover } from "antd";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import classnames from "../../utils/classnames.js";
import LocationList from "./LocationList.js";
import './LocationSelect.css';/* empty css                    */
const DEFAULT_VALUE = "Укажите местоположение";
const DEFAULT_LABEL = "Ваш город";
const DEFAULT_PLACEHOLDER = "Начните ввод";
const DEFAULT_ERROR_MESSAGE = "К сожалению, поиск не дал результатов";
const LocationSelect = React__default.forwardRef(
  function LocationSelect2({
    defaultValue = DEFAULT_VALUE,
    items,
    label = DEFAULT_LABEL,
    placeholder = DEFAULT_PLACEHOLDER,
    errorMessage = DEFAULT_ERROR_MESSAGE,
    className,
    onChange,
    open = false
  }, ref) {
    const [selectedItem, setSelectedItem] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const handleItemSelect = (item) => {
      setIsOpen(false);
      setSelectedItem(item);
      onChange(item);
    };
    useEffect(() => {
      setIsOpen(open);
    }, [open]);
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: classnames(
          [
            "perxis-auto-location-select",
            {
              "perxis-auto-location-select--open": isOpen
            }
          ],
          className
        ),
        children: /* @__PURE__ */ jsx(
          Popover,
          {
            trigger: "click",
            placement: "bottom",
            open: isOpen,
            arrow: false,
            onOpenChange: setIsOpen,
            content: /* @__PURE__ */ jsx(
              LocationList,
              {
                items,
                onSelect: handleItemSelect,
                label,
                selected: selectedItem,
                placeholder,
                errorMessage
              }
            ),
            rootClassName: classnames("perxis-auto-location-select__popover"),
            children: /* @__PURE__ */ jsx(
              Button,
              {
                type: "text",
                icon: /* @__PURE__ */ jsx(Icon, { name: "geo", size: 24, sticker: "location-select-geo-icon" }),
                iconPosition: "right",
                iconGapSize: "normal",
                className: classnames("perxis-auto-location-select__title"),
                children: (selectedItem == null ? void 0 : selectedItem.name) || defaultValue
              }
            )
          }
        )
      }
    );
  }
);
export {
  LocationSelect as default
};
//# sourceMappingURL=LocationSelect.js.map
